/* eslint-disable react-refresh/only-export-components */
import { FC, lazy, LazyExoticComponent } from 'react';

import { routingConfig } from '../consts';
import { RouteWithComponent } from '../interfaces';

const ContactDataConfirmView: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/contactDataConfirm/contactDataConfirm.view')
);
const EmailVerification: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/emailVerification/emailVerification')
);
const AnonSurvey: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/anonSurvey/anonSurvey.component')
);
const Certificates: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/certificates/certificates.component')
);
const Competence: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/competence/competence.component')
);
const Dashboard: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/dashboard/dashboard.component')
);
const Form: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/form/form.component')
);
const Gamification: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/gamification/gamification.component')
);
const Idd: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/idd/idd.component')
);
const News: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/news/news.component')
);
const Onboarding: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/onboarding/onboarding.component')
);
const Profile: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/profile/profile.component')
);
const Surveys: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/surveys/surveys.component')
);
const TeamIndicators: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/teamIndicators/teamIndicators.component')
);
const Training: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/training/training.component')
);
const Trainings: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/trainings/trainings.component')
);
const VideoPlayer: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/videoPlayer/videoPlayer.component')
);
const AuthView: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/authView/authView')
);
const PasswordRemind: LazyExoticComponent<FC> = lazy(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (): Promise<any> => import('../userContext/passwordRemind')
);
const InfoClauseContent: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/regulations/views/infoClauseContent/infoClauseContent.view')
);
const PrivacyPolicyContent: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/regulations/views/privacyPolicyContent/privacyPolicyContent.view')
);
const RegulationsContent: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/regulations/views/regulationsContent/regulationsContent.view')
);
const TrainingRegulationsContent: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/regulations/views/trainingRegulationsContent/trainingRegulationsContent.view')
);
const UsersAdministration: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/usersAdministration/usersAdministration')
);
const Substitutions: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/substitutions/substitutions')
);
const Lesson: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../lesson')
);
const KnowledgeBase: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/knowledgeBase/knowledgeBase.component')
);
const Notifications: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../modules/notifications/notifications.component')
);
const ComparisonTable: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/comparisonTable/comparisonTable.view')
);
const LegalForms: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/legalForms/legalForms')
);
const IncomingAuthView: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('../pages/incomingAuth/incomingAuth.view')
);

export const routes: RouteWithComponent[] = [
  { pathSettings: routingConfig.base.children.confirmEmail, component: EmailVerification },
  { pathSettings: routingConfig.base.children.emailVerification, component: EmailVerification },
  { pathSettings: routingConfig.base.children.anonSurvey, component: AnonSurvey },
  { pathSettings: routingConfig.certificates, component: Certificates },
  { pathSettings: routingConfig.competences, component: Competence },
  { pathSettings: routingConfig.base.children.dashboard, component: Dashboard },
  { pathSettings: routingConfig.base.children.form, component: Form },
  { pathSettings: routingConfig.gamification, component: Gamification },
  { pathSettings: routingConfig.base.children.idd, component: Idd },
  { pathSettings: routingConfig.news, component: News },
  { pathSettings: routingConfig.base.children.onboarding, component: Onboarding },
  { pathSettings: routingConfig.profile, component: Profile },
  { pathSettings: routingConfig.base.children.surveys, component: Surveys },
  { pathSettings: routingConfig.teamIndicators, component: TeamIndicators },
  { pathSettings: routingConfig.base.children.trainingDetails, component: Training },
  { pathSettings: routingConfig.base.children.trainings, component: Trainings },
  { pathSettings: routingConfig.base.children.videoPlayer, component: VideoPlayer },
  { pathSettings: routingConfig.base.children.signIn, component: AuthView },
  { pathSettings: routingConfig.base.children.registration, component: AuthView },
  { pathSettings: routingConfig.base.children.accountActivation, component: AuthView },
  { pathSettings: routingConfig.base.children.remindPassword, component: PasswordRemind },
  { pathSettings: routingConfig.base.children.contactDataConfirm, component: ContactDataConfirmView },
  { pathSettings: routingConfig.base.children.preAccountRegistration, component: AuthView },
  { pathSettings: routingConfig.base.children.regulations, component: RegulationsContent },
  { pathSettings: routingConfig.base.children.privacyPolicy, component: PrivacyPolicyContent },
  { pathSettings: routingConfig.base.children.trainingRegulations, component: TrainingRegulationsContent },
  { pathSettings: routingConfig.base.children.informationDuty, component: InfoClauseContent },
  { pathSettings: routingConfig.usersAdministration, component: UsersAdministration },
  { pathSettings: routingConfig.substitutions, component: Substitutions },
  { pathSettings: routingConfig.base.children.knowledgeBaseLesson, component: Lesson },
  { pathSettings: routingConfig.base.children.knowledgeBase, component: KnowledgeBase },
  { pathSettings: routingConfig.base.children.notifications, component: Notifications },
  { pathSettings: routingConfig.base.children.comparisonTable, component: ComparisonTable },
  { pathSettings: routingConfig.legalForms, component: LegalForms },
  { pathSettings: routingConfig.base.children.incomingAuth, component: IncomingAuthView },
];
